import { useMergeRefs } from '@floating-ui/react';
import React from 'react';

import { nameof } from '../../../../../utils/nameof';
import { useSettingsPanelState } from './settings-panel-context';

const SettingsPanelTrigger = React.forwardRef<HTMLElement, React.HTMLProps<HTMLElement>>(
  ({ children, ...props }, propRef) => {
    const state = useSettingsPanelState();
    const ref = useMergeRefs([state.refs.setReference, propRef]);

    return React.isValidElement(children)
      ? React.cloneElement(
          children,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          state.getReferenceProps({
            ref,
            ...props,
            ...children.props,
          }),
        )
      : null;
  },
);

SettingsPanelTrigger.displayName = nameof({ SettingsPanelTrigger });

export { SettingsPanelTrigger };
